<!--添加故障报备-->
<template>
    <div class="faultForm">
        <van-nav-bar
            title="故障台账"
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-form ref="faultForm">
            <h2 class="title baseInfo-title">
                <i class="iconfont icondanjubianhao"></i>基本信息
            </h2>
            <van-field
                v-model="form.accident"
                label="车辆位置"
                :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                placeholder="请选择车辆位置"
                :rules="[{ required: true, message: '请选择车辆位置' }]"
                input-align="right"
                @click="viewCarPosition"
            ></van-field>
            <!--            @click="viewCarPosition"-->

            <van-field
                v-model="form.licensenumber"
                label="车牌号"
                :left-icon="require('@/assets/images/icons/icon_gy_9.png')"
                placeholder="请输入车牌号"
                :rules="[{ required: true, message: '请输入车牌号' }]"
                input-align="right"
            ></van-field>
            <van-field
                v-model="form.carnumber"
                label="车小号"
                :left-icon="require('@/assets/images/icons/icon_18.png')"
                placeholder="请输入车小号"
                :rules="[{ required: true, message: '请输入车小号' }]"
                input-align="right"
            ></van-field>
            <van-field
                v-model="form.driver"
                label="驾驶员"
                :left-icon="require('@/assets/images/icons/icon_3.png')"
                placeholder="请输入驾驶员"
                :rules="[{ required: true, message: '请输入驾驶员' }]"
                input-align="right"
            ></van-field>
            <van-field
                v-model="form.phone"
                label="联系电话"
                :left-icon="require('@/assets/images/icons/icon_4.png')"
                placeholder="请输入联系电话"
                :rules="[{ required: true, message: '请输入联系电话' }]"
                input-align="right"
            ></van-field>
            <van-field
                v-model="form.reportedtime"
                label="时间"
                :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                placeholder="请输入时间"
                :rules="[{ required: true, message: '请选择时间' }]"
                input-align="right"
                @click="showPicker = true"
            ></van-field>
            <van-popup v-model="showPicker" position="bottom">
                <van-datetime-picker
                    v-model="timeDate"
                    type="datetime"
                    @confirm="onConfirmPicker"
                    @cancel="showPicker = false"
                ></van-datetime-picker>
            </van-popup>
            <h2 class="title">
                <i class="iconfont icondanjubianhao"></i>故障类型
            </h2>
            <div class="accent-type">
                <template v-for="item in accentTypes">
                    <div
                        :class="{'type-item':true,'active':item.val == form.accidenttype }"
                        :key="item.val"
                        @click="changeAccent(item.val)"
                    >
                        {{ item.name }}
                        <template v-if="item.val==3">
                            <van-popover
                                v-model="showPopover"
                                trigger="click"
                                :get-container="getContainer"
                                style="height: 0"
                                :offset="[0,10]"
                            >
                                <div class="responsibility">
                                    <div
                                        v-for="traffic in traffictypes"
                                        :key="traffic.name"
                                        :class="{'type-item':true,'active2':traffic.val == form.traffictype }"
                                        @click="changeTraffic(traffic.val)"
                                    >
                                        {{ traffic.name }}
                                    </div>
                                </div>
                                <template #reference>
                                    <div class="type-item" style="height:0;opacity: 0"></div>
                                </template>
                            </van-popover>
                        </template>
                    </div>
                </template>
                <div class="popover-contain"></div>
            </div>
            <h2 class="title">
                <i class="iconfont icondanjubianhao"></i>添加影像资料
            </h2>
            <div class="video-img-list">
                <van-uploader
                    v-model="fileList"
                    preview-image
                    preview-full-image
                    multiple
                    :max-count="10"
                    :max-size="10000 * 1024"
                    @oversize="onOversize"
                    upload-icon="plus"
                ></van-uploader>
            </div>
            <div class="edit-input">
                <van-field
                    v-model="form.describe"
                    rows="3"
                    autosize
                    label=""
                    type="textarea"
                    maxlength="300"
                    placeholder="请输入留言"
                    show-word-limit
                >
                    <template slot="left-icon">
                        <i class="iconfont iconyijian"></i>
                    </template>
                </van-field>
            </div>
        </van-form>
        <div class="footer">
            <div class="submit-btn" @click="submitForm">
                报备
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '@/utils/util';
export default {
    name: 'fault-form',
    data() {
        return {
            form: {
                Id: '', // 故障数据id
                driver: '',
                phone: '',
                licensenumber: '', // 车牌号
                accidenttype: 0, // 1车辆故障、2车辆超载、3交通事故、4其他
                traffictype: 0, // 1对方责任、2我方责任 3双方责任
                reportedtime: '', // 报备时间
                accident: '', // 事故地
                describe: '', // 描述
                result: '', // 处理结果
                lastresult: '', // 最后处理结果
                status: 0, // 处理状态 0：新上报 1：未处理 2： 已处理 3: 已办结
                station: '', // 车辆隶属场站
                company: '', // 所属公司
                motorcade_id: '', // 车队id
                userid: '', // 司机id
                is_publish: 0, // 是否发布

                filepath: '', // 文件
                carnumber: '', // 车小号
                longlat: '', // 经纬度
            },
            fileList: [],
            showPopover: false,
            showPicker: false,
            timeDate: new Date(),
            accentTypes: [{
                name: '车辆故障',
                val: 1,
            }, {
                name: '车辆超载',
                val: 2,
            }, {
                name: '交通事故',
                val: 3,
            }, {
                name: '其他',
                val: 4,
            }],
            traffictypes: [{
                name: '我方责任',
                val: 1,
            }, {
                name: '对方责任',
                val: 2,
            }, {
                name: '双方责任',
                val: 3,
            }],
            fileIds: [],
            aliyunOssToken: null,
            buCode: 'ProductionAffix',
        };
    },
    created() {
        window.jyCallback_DriverUntieVehicle = this.jyCallback_DriverUntieVehicle;
        this.initData();
    },
    mounted() {
        // 获取上传文件信息
        const aliy = localStorage.getItem('aliyunOssToken') ? JSON.parse(localStorage.getItem('aliyunOssToken')) : null;
        const date = new Date();
        if (aliy && aliy.expire && aliy.expire * 1000 > date.getTime()) {
            this.aliyunOssToken = aliy;
        } else {
            this.getOssToken();
        }
    },
    methods: {
        getContainer() {
            return document.querySelector('.popover-contain');
        },
        initData() {
            this.form.Id = this.$route.query.Id || '';
            this.form.reportedtime = Utils.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            if (this.form.Id) {
                this.getDataInfo();
            } else {
                this.getCurrentPosition();
            }
        },
        // 获取详情 编辑时
        getDataInfo() {
            this.$axios.get('/interfaceApi/logistics/car_feedback/get_carfeedbackbyid?id=' + this.form.Id)
                .then(res => {
                    this.form = res;
                    if (res.filepath) {
                        const fileIds = res.filepath.split(',');
                        this.initFileList(fileIds);
                    }
                });
        },
        // 提交数据
        submitForm() {
            this.$refs.faultForm.validate()
                .then(async () => {
                    this.$toast.loading({
                        message: '提交中...',
                        forbidClick: true,
                        duration: 0,
                    });
                    // 修改
                    if (this.form.Id) {
                        // 处理文件
                        await this.saveFile();
                        this.$axios.post('/interfaceApi/logistics/car_feedback/update_carfeedback', this.form)
                            .then(async () => {
                                this.$toast.clear();
                                this.$toast.success('报备成功');
                                this.onClickLeft();
                            })
                            .catch(error => {
                                this.$toast(error.ErrorCode.Message);
                            });
                    } else { // 添加
                        this.form.Id = Utils.getGuid();
                        await this.saveFile();
                        this.$axios.put('/interfaceApi/logistics/car_feedback/add_carfeedback', this.form)
                            .then(async () => {
                                this.$toast.clear();
                                this.$toast.success('报备成功');
                                this.onClickLeft();
                            })
                            .catch(error => {
                                this.form.Id = '';
                                this.$toast.clear();
                                this.$toast(error.ErrorCode.Message);
                            });
                    }
                });
        },
        // 故障类型
        changeAccent(val) {
            this.form.accidenttype = val;
            this.showPopover = val === 3;
        },
        // 故障类型
        changeTraffic(val) {
            this.form.traffictype = val;
        },
        onOversize() {
            this.$toast.fail('文件大小不能超过10mb');
        },
        // 确认选择时间
        onConfirmPicker(time) {
            this.form.reportedtime = Utils.timeFormat(time, 'yyyy-MM-dd HH:mm:ss');
            this.showPicker = false;
        },
        // 查看车辆位置
        viewCarPosition() {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/carPosition',
                query: {
                    longlat: this.form.longlat,
                },
            },);
        },
        // 编辑保存文件
        async saveFile() {
            const files = [];
            this.fileList.forEach(item => {
                if (item.file) {
                    files.push(item.file);
                } else {
                    this.fileIds.push(item.id);
                }
            });
            this.uploadRequest(files, this.form.Id);
            this.$nextTick(() => {
                this.form.filepath = this.fileIds.join();
            });
        },
        // 初始化处理文件列表
        initFileList(fileIds) {
            fileIds.forEach(fileId => {
                this.getFileDetailFun(fileId);
            });
        },
        // 获取文件下载预览地址
        getFileDetailFun(item) {
            this.$axios
                .get(this.GLOBAL.FILE_BASE_URL_OSS + 'api/GetFileInfo/' + item)
                .then(res => {
                    this.fileList.push({
                        url: res.preview_url,
                        id: item,
                        isImage: true,
                    });
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 上传附件请求
        uploadRequest(files, data_id) {
            files.forEach(file => {
                this.upGroupFun(file, data_id);
            });
        },
        // 获取上传通行证
        getOssToken() {
            this.$axios.get(this.GLOBAL.FILE_BASE_URL_OSS + `credential/GetPostPolicy/${this.buCode}`).then(res => {
                if (res) {
                    this.aliyunOssToken = res;
                    // localStorage.setItem('aliyunOssToken', JSON.stringify(res));
                }
            });
        },
        // 上传组名
        upGroupFun(val, data_id) {
            const filename = val ? val.name : '现场照片';
            // 判断是否过期，过期重新调用获取通信证方法
            const formData = new FormData();
            // 注意formData里append添加的键的大小写
            formData.append('key', `${this.aliyunOssToken.dir}${data_id}/${filename}`); // 存储在oss的文件路径
            formData.append('OSSAccessKeyId', this.aliyunOssToken.accessid); // accessKeyId
            formData.append('policy', this.aliyunOssToken.policy); // policy
            formData.append('Signature', this.aliyunOssToken.signature); // 签名
            // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', val ? val : filename);
            // formData.append('FileDescription', this.newFile.FileDescription);
            formData.append('success_action_status', 200); // 成功后返回的操作码
            formData.append('Content-Type', 'multipart/form-data'); // 成功后返回的操作码

            // 回调参数
            const obj = {
                bucket: this.aliyunOssToken.bucket ? this.aliyunOssToken.bucket : this.buCode, // 存储桶名称
                business_type_code: this.buCode, // 业务类型编码
                object_name: `${this.aliyunOssToken.dir}${data_id}/${filename}`, // 文件对象名
                show_name: filename, // 显示文件名
                size: 0, // 文件大小
                mimeType: '',
                mime_type: val ? val.type : '',
                data_id: data_id, // 业务数据id
                directory_id: '', // 目录id
                tenant_id: this.$takeTokenParameters('TenantId'), // 租户id
                // FileDescription: this.newFile.FileDescription, // 文件描述
            };
            this.uploadFun(formData, obj);
        },
        // 上传文件
        uploadFun(formData, val) {
            this.$.ajax({
                url: this.aliyunOssToken.host,
                type: 'POST',
                data: formData,
                cache: false, // 不缓存数据
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: data => { // 成功回调
                    this.callBackFun(val);
                },
            });
        },
        // 上传的回调
        callBackFun(obj) {
            this.$axios.post(this.GLOBAL.FILE_BASE_URL_OSS + 'api/UploadCallback', obj).then(res => {
                if (res) {
                    this.fileIds.push(res.id);
                }
            });
        },
        // 获取当前定位
        getCurrentPosition() {
            this.$callMobile('JYExternalNative', 'jyDriverUntieVehicleEvent');
        },
        // 获取原生定位后回调
        jyCallback_DriverUntieVehicle(data) {
            const dataParse = JSON.parse(data);
            this.form.longlat = dataParse.longitude + ',' + dataParse.latitude;
            this.form.accident = dataParse.address;
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.back();
        },
    },
};
</script>

<style lang="stylus" scoped>
.faultForm{
    box-sizing border-box;
    width 100%;
    height 100%;
    .van-form{
        width 100%;
        height 100%;
        overflow-y auto
        padding-bottom 110rpx;
        >>> .van-field__error-message{
            display none;
        }
        .title{
            display flex
            align-items center
            height 48rpx;
            padding-left 13rpx;
            font-size 18rpx;
            color #3495FB
            .iconfont{
                margin-right 7rpx;
            }
            &.baseInfo-title{
                border-bottom: 1px solid #ebedf0;
            }
        }
        .accent-type{
            border-bottom: 1px solid #ebedf0;
            padding-left 14rpx;
            display flex
            flex-wrap wrap
            .type-item{
                width: 80rpx;
                height: 30rpx;
                background: #F1F1F1;
                border-radius: 4rpx;
                display flex
                justify-content center
                align-items center
                flex-direction column;
                font-size 14rpx;
                color #666;
                margin 0 9rpx 9rpx 0;
                position relative
                &.active{
                    background #FEE5E5;
                    color #E60000
                }
                &.active2{
                    background #FFFADD;
                    color #FF6600
                }
            }
            .popover-contain{
                width 100%;
                >>> .van-popover__content{
                    border-radius 0;
                }
                .responsibility{
                    display flex
                    padding 15rpx 6rpx 6rpx 15rpx;
                    background: #FFFFFF;
                    box-shadow: 0px 2rpx 4rpx 0px rgba(0, 0, 0, 0.2);
                }
            }
        }
        .video-img-list{
            padding-left 16rpx;
            padding-bottom 10rpx;
            border-bottom: 1px solid #ebedf0;
        }
        .edit-input{
            margin 20rpx auto;
            width: 94%;
            min-height: 132rpx;
            border-radius: 4rpx;
            border: 1px solid #D7D7D7;
            .iconyijian{
                font-size 16rpx;
                color #979EA7
                margin-right 10rpx;
            }
        }
    }
    .footer{
        position: fixed;
        left 0;
        bottom 0;
        width 100%;
        padding 15rpx;
        background #fff;
        .submit-btn{
            width: 100%;
            height: 40rpx;
            background: #D6000F;
            border-radius: 4rpx;
            display flex
            justify-content center
            align-items center
            color #fff;
            font-size 16rpx;
        }
    }
}
</style>
